import axios from 'axios';

export const PURCHASE_STAGES = ['PR', 'PO', 'PD', 'PI'];

export async function getPurchaseWorkflow() {
  const { data } = await axios.get(global.SET_API_URL + 'purchaseWorkflowSettings/');
  const startStage = String(data?.data?.startStage || 'PR').toUpperCase();
  return { startStage, enabledStages: PURCHASE_STAGES.slice(Math.max(0, PURCHASE_STAGES.indexOf(startStage))) };
}

export const isPurchaseStageEnabled = (startStage, stage) =>
  PURCHASE_STAGES.indexOf(stage) >= PURCHASE_STAGES.indexOf(startStage || 'PR');
